export const EMAIL_REGEX = /^[A-Z0-9'._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,18}$/i; // Grubhub Roux
export const NAME_REGEX = /^[a-z0-9 ,.'()_|/@&#-]+\s*$/i;
export const INPUT_REGEX = /^[a-zA-Z0-9|_@\\;:/.\-,+*()'&#!\s]+$/;
export const NUMBERS_ONLY_REGEX = /^[0-9]+$/;
export const LETTERS_ONLY_REGEX = /^[a-zA-Z]+$/;
export const LETTERS_AND_SPACES_REGEX = /^[a-zA-Z\s]+$/;
export const TIME_REGEX = /^(0?[0-9]|1[0-2]):[0-5][0-9]$/;

// This is not just valid URL regex, but it's specific to SSO redirect URLs and copied from backend.
const SSO_REDIRECT_URL_REGEX_STRING =
  '^https?:\\/\\/(?:www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b(?:[-a-zA-Z0-9()@:%_\\+.~#?&\\/=]*)$';
export const SSO_REDIRECT_URL_REGEX = new RegExp(SSO_REDIRECT_URL_REGEX_STRING);
